import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import React, { CSSProperties, useState } from 'react';
import {
  ClassSchedule,
  LecturerWithActivityType,
} from '../../../../../../../../api/types/programs/course/exams/response/exam-metadata';
import '../../exam-page.css';
import dateUtils from '../../../../../../../../utils/date-format';
import { Button } from 'primereact/button';
import ClassIcon from '../../../../../../../../assets/icons/menu-icons/classes.svg';
import { Accordion, AccordionTab } from 'primereact/accordion';

interface LecturerScheduleTableDatamodel {
  displayHeader: boolean;
  protectors: LecturerWithActivityType[];
  classSchedule: ClassSchedule | null;
  setClassSchedule: (schedule: ClassSchedule | null) => void;
}
export const LecturerScheduleTable: React.FC<
  LecturerScheduleTableDatamodel
> = ({ protectors, displayHeader, classSchedule, setClassSchedule }) => {
  const style: CSSProperties = { width: '100px' };

  const headerStyle: CSSProperties = {
    width: '100px',
  };

  const header = () => {
    const data = classSchedule;

    return (
      <div
        style={{
          display: 'flex',

          alignItems: 'center',

          justifyContent: 'space-between',
          backgroundColor: '#f9fafb',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          {/*<label style={{ fontSize: '16px' }}>שעות</label>*/}
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              marginRight: '16.5px',
              alignItems: 'center',
            }}
          >
            <i style={{ fontSize: '24px' }} className="pi pi-clock"></i>
            <label
              style={{
                fontSize: '30px',
                marginRight: '4px',
                direction: 'ltr',
              }}
            >
              {/*14:00 - 16:00*/}
              {data &&
                dateUtils.formatTimeRangeBetweenDates(data.startAt, data.endAt)}
            </label>
          </div>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
            }}
          >
            <img src={ClassIcon} width={24} />
            <label style={{ fontSize: '30px', marginRight: '4px' }}>
              {data && data.className}
            </label>
          </div>
        </div>

        <Button
          className={'custom-tooltip-btn'}
          style={{ height: '35px', width: '35px' }}
          severity={'secondary'}
          icon="pi pi-plus"
          tooltip={'לחץ להוספת משגיחים לבחינה'}
          onClick={() => setClassSchedule(data)}
        />
      </div>
    );
  };

  const [expandedRows, setExpandedRows] = useState();

  console.log(`XXXXX data res: ${JSON.stringify(expandedRows)}`);

  return (
    <div>
      <Accordion activeIndex={0}>
        <AccordionTab header={<div>{header()}</div>}>
          <DataTable
            value={protectors}
            showHeaders={displayHeader}
            dataKey="id"
            tableStyle={{ minWidth: '50rem', direction: 'rtl' }}
            emptyMessage={
              <div style={{ textAlign: 'right', visibility: 'hidden' }}>
                לא נמצאו נתונים
              </div>
            }
          >
            <Column
              style={{ textAlign: 'right', height: '40px' }}
              field="firstName"
              header="שם המרצה"
              headerStyle={headerStyle}
              body={(rowData: LecturerWithActivityType) => (
                <div style={{ ...style }}>
                  {rowData.firstName} {rowData.lastName}
                </div>
              )}
            />

            <Column
              style={{ textAlign: 'right', height: '40px' }}
              field="שלוחה"
              header="ת.ז"
              headerStyle={headerStyle}
              body={(rowData: LecturerWithActivityType) => (
                <div style={{ ...style }}>{rowData.nationalId}</div>
              )}
            />

            <Column
              style={{ textAlign: 'right', height: '40px' }}
              field="שלוחה"
              header="סוג פעילות"
              headerStyle={headerStyle}
              body={(rowData: LecturerWithActivityType) => (
                <div style={{ ...style }}>{rowData.typeRateName}</div>
              )}
            />

            <Column
              style={{ textAlign: 'right', height: '40px' }}
              field="שלוחה"
              header="שעת התחלה"
              headerStyle={headerStyle}
              body={(rowData: LecturerWithActivityType) => (
                <div style={{ ...style }}></div>
              )}
            />

            <Column
              style={{ textAlign: 'right', height: '40px' }}
              field="שלוחה"
              header="שעת סיום"
              headerStyle={headerStyle}
              body={(rowData: LecturerWithActivityType) => (
                <div style={{ ...style }}></div>
              )}
            />
          </DataTable>
        </AccordionTab>
      </Accordion>
    </div>
  );
};
